import { to2Digits, isEven, screenWidthGreaterThan } from 'helpers';
import { HeadingParagraph } from 'Types/ILanguage';
import { InfoCard } from 'components';
import iPhoneFast from 'assets/iPhone_fast.png';
import iPhoneAdvantageous from 'assets/iPhone_advantageous.png';
import iPhoneNearby from 'assets/iPhone_nearby.png';
import iPhoneGroundBreaking from 'assets/iPhone_groundbreaking.png';

// import { useRef, useEffect } from 'react';
interface IProps {
	features: HeadingParagraph[];
}

const Feature: React.FC<IProps> = ({ features }) => {
	const feature = features.map((el, idx) => {
		let image: string;
		switch (idx) {
			case 0:
				image = iPhoneFast;
				break;
			case 1:
				image = iPhoneAdvantageous;
				break;
			case 2:
				image = iPhoneNearby;
				break;
			case 3:
				image = iPhoneGroundBreaking;
				break;
			default:
				image = iPhoneFast;
		}

		// UNO)
		const reverse = isEven(idx) ? 'abs--l0' : 'abs--r0';

		const featureInfoClass = `section3__feature--info ${reverse}`;
		return screenWidthGreaterThan(1100) ? (
			<div key={idx} className="section3__feature">
				<div className={featureInfoClass} data-value={to2Digits(idx + 1)}>
					<h3 className="section3__feature-heading">{el.heading}</h3>
					<p>{el.paragraph}</p>
				</div>

				<img src={image} className="section3__feature-image" alt="iPhone" />
			</div>
		) : (
			<InfoCard key={idx} heading={el.heading} text={el.paragraph} image={image} />
		);
	});

	return <>{feature}</>;
};

export default Feature;
